module.exports = __webpack_public_path__ + "static/img/CharlieCurnow.a562bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CharlieCurnow.jpg
// module id = vY9M
// module chunks = 0